import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import Layout from '../containers/Layout';
import Preloader from '../components/Preloader';

const PrivateRoute = ({ component: Component, data, ...rest }) => {
	return <Route {...rest} render={props => (
		data.isLoggedin ?
			(data.isModulesLoaded ?
				(data.isAvalaible ? <Layout location={rest.location} redBackground={rest.redBackground}><Component {...props} /></Layout> : <Redirect to={data.firstNavigationPath} />) :
				<Layout {...props}><Preloader /></Layout>
			) : <Redirect to="/login" />
	)}/>
}

PrivateRoute.propTypes = {
	component: PropTypes.any,
	data: PropTypes.object.isRequired
}

export default PrivateRoute;



// WEBPACK FOOTER //
// ./components/PrivateRoute.js